<template>
  <div :class="theme">
    <transition-group
      id="main-nav"
      tag="ul"
      :name="transitionName"
      :class="[theme, 'desktop-nav', {'animations-disabled': disableMenuAnimations}, {'scrolled': isScrolled}]"
    >
      <li
        ref="li"
        v-for="item in navigationMenu"
        :key="item.id"
      >
        <router-link
          :to="item.path"
          :class="{active: $route.path.indexOf(item.path) > -1}"
        >
          {{ item.title }}
          <span class="menu-counter">{{ item.counter }}</span>
        </router-link>
      </li>
    </transition-group>
    <div v-if=isMobile>
      <div class="mobile-navbar-bar"></div>
      <a href="/main" class="logo-mobile">Mobidev Design</a>
      <span @click="toggleMobileMenu" :class="['burger-menu', { 'close-menu': isMobileMenuOpen }]"></span>
      <div v-if=isMobileMenuOpen class="overlay"></div>
        <ul :class="['mobile-menu-content', { 'is-open': isMobileMenuOpen }]">
        <li
          ref="li"
          v-for="item in navigationMenu"
          :key="item.id"
          @click="closeMenuOnClick"
        >
          <router-link
            :to="item.path"
            :class="{active: $route.path.indexOf(item.path) > -1}"
          >
            {{ item.title }}
          </router-link>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
// import debounce from 'lodash.debounce';
import uuidv4 from 'uuid/v4';

export default {
  data() {
    return {
      isMobile: window.innerWidth <= 1000,
      theme: '',
      disableMenuAnimations: true,
      isMobileMenuOpen: false,

      isScrolled: false,

      navigationMenu: [
        {
          id: uuidv4(),
          path: '/main',
          title: 'Main',
          theme: 'white',
          counter: 1,
        },
        {
          id: uuidv4(),
          path: '/portfolio',
          title: 'Portfolio',
          // theme: 'white',
          counter: 2,
        },
        {
          id: uuidv4(),
          path: '/team',
          title: 'Team',
          counter: 3,
        },
        // {
        // id: uuidv4(),
        // path: '/resources',
        // title: 'Resources',
        // },
        {
          id: uuidv4(),
          path: '/process',
          title: 'Process',
          counter: 4,
        },
        {
          id: uuidv4(),
          path: '/expertise',
          title: 'Expertise',
          counter: 5,
        },
      ],
    };
  },

  computed: {
    ...mapState({
      transitionName: state => `nav-${state.ui.transitionName}`,
    }),

    navigationMenuSize() {
      return this.navigationMenu.length;
    },

    navigationMenuCenterIndex() {
      return Math.ceil(this.navigationMenuSize / 2) - 1;
    },
  },

  watch: {
    '$route'({ path }) {
      this.updateMenuLayout(path);
      this.isMobileMenuOpen = false;
      this.isScrolled = false;
    },
  },

  created() {
    this.updateMenuLayout(this.$router.currentRoute.path);
  },

  mounted() {
    this.disableMenuAnimations = false;
    window.addEventListener('resize', this.updateWindowWidth);

    window.addEventListener('scroll', this.handleScroll, true);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowWidth);

    window.removeEventListener('scroll', this.handleScroll, true);
  },

  methods: {
    // handleScroll() {
    // this.isScrolled = window.scrollY > 70;
    // },
    handleScroll(e) {
      if (e.target && e.target.scrollTop !== undefined) {
        this.isScrolled = e.target.scrollTop > 70;
      }
    },
    ...mapActions({
      setTransitionName: 'ui/transitionName:set',
      toggleMobileMenu() {
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
      },
      closeMenuOnClick() {
        this.isMobileMenuOpen = false;
      },
      updateWindowWidth() {
        this.isMobile = window.innerWidth <= 1000;
      },
    }),

    updateMenuLayout(path) {
      const activeItem = this.navigationMenu.find(item => path.indexOf(item.path) > -1);

      if (!activeItem) return;

      this.theme = activeItem.theme;
      if (!this.isMobile) {
        this.centerActiveItem(activeItem);
      }
    },

    centerActiveItem(activeItem) {
      const activeItemIndex = this.navigationMenu.findIndex(item => item === activeItem);
      const indexDifference = this.navigationMenuCenterIndex - activeItemIndex;

      const side = indexDifference < 0 ? 'left' : 'right';
      const amountToShift = Math.abs(indexDifference);

      // if (amountToShift === 0) {
      //   this.setTransitionName('none');
      // } else {
      //   this.setTransitionName(`slide-${side}`);
      //   this.prepareItemsForAnimation();
      //   this.shiftSideItems(side, amountToShift);
      // }

      if (amountToShift === 0) {
        this.setTransitionName('none');
      } else {
        this.setTransitionName(`slide-${side}`);
        this.$nextTick(() => {
          this.prepareItemsForAnimation();
          this.shiftSideItems(side, amountToShift);
        });
      }
    },

    prepareItemsForAnimation() {
      if (!Array.isArray(this.$refs.li)) return;
      this.$refs.li.forEach((item) => {
        // eslint-disable-next-line no-param-reassign
        item.style.left = `${item.offsetLeft}px`;
      });
    },

    shiftSideItems(side, amountToShift) {
      if (amountToShift === 0) return;

      const index = this.navigationMenuSize - amountToShift;

      const deleteFromIndex = side === 'right' ? index : 0;
      const insertAtIndex = side === 'right' ? 0 : index;

      const extractedItems = this.navigationMenu
        .splice(deleteFromIndex, amountToShift)
        .map(item => ({ ...item, id: uuidv4() }));

      this.navigationMenu.splice(insertAtIndex, 0, ...extractedItems);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UI/MainNav.vue